import {levenshteinEditDistance} from "levenshtein-edit-distance";
import { Collection } from "../../models/Collection";


export const getGroupSuggestions = (arr: Collection[], valueForSuggest: string, size: number = 10): Collection[] => {
  const suggestions = arr.map(suggestion => ({
    ...suggestion,
    distance: calcMinDistance(valueForSuggest, [  suggestion.title ])
  }))
    .sort((a, b) => a.distance - b.distance)
    .slice(0, size)
    .map(({distance, ...rest}) => ({...rest}))
  return suggestions
}


const calcMinDistance = (valueForSuggest: string, input: string[]) => {
    const distances = input.map(value => calcDistance(valueForSuggest, value))
    const min = Math.min(...distances)
    return min
}

const calcDistance = (valueForSuggest: string, input: string) => {
    const v = !!valueForSuggest ? valueForSuggest.toLowerCase() : ''
    const i = !!input ? input.toLowerCase() : ''
    const levenshteinDistance = levenshteinEditDistance(i, v)

    const normalDistance = levenshteinDistance / Math.max(i.length, v.length)
    return normalDistance
}